module.exports = __webpack_public_path__ + "static/media/181-trinidad-and-tobago.085e80b4.svg";